<template>
    <nav-bar></nav-bar>
</template>

<script>
import navBar from "./navBar"

export default {
    name: "home",
    components: {
        navBar,
    }
}
</script>

<style scoped lang="scss">

</style>